import { COLORS_DATA } from "components/PopupEditPage/EditPage/FormEdit/consts"

export const MOCK_USER_DATA = {
    file: null,
    name: 'Nona Marie Invie',
    link: '',
    about: 'Hey, I’m Warsaw based game designer and 3d artist. I currently work at Blue Twelve Studio.',
    twitter: null,
    instagram: 'testinst',
    facebook: null,
    defaultColor: COLORS_DATA[3].value,
    patrons: '4,5K',
    drizzles: '919K',
    votes: '497',
    position: 17
}